import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * JetBrains Icon component based on the provided logo SVG.
 * - `colored=true`: official gradient/black/white logo colors.
 * - `colored=false`: monochrome using currentColor.
 */
export default function JetBrainsIcon({colored = false, ...props}: {
    colored?: boolean;
} & SvgIconProps) {
    const gradientId = React.useId();

    return (
        <SvgIcon {...props} viewBox="-4 -4 72 72">
            {colored && (
                <defs>
                    <linearGradient id={gradientId} x1=".850001" x2="62.62" y1="62.72" y2="1.81" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FF9419"/>
                        <stop offset=".43" stopColor="#FF021D"/>
                        <stop offset=".99" stopColor="#E600FF"/>
                    </linearGradient>
                </defs>
            )}

            {colored && <path
                fill={colored ? `url(#${gradientId})` : 'currentColor'}
                d="M20.34 3.66 3.66 20.34C1.32 22.68 0 25.86 0 29.18V59c0 2.76 2.24 5 5 5h29.82c3.32 0 6.49-1.32 8.84-3.66l16.68-16.68c2.34-2.34 3.66-5.52 3.66-8.84V5c0-2.76-2.24-5-5-5H29.18c-3.32 0-6.49 1.32-8.84 3.66Z"
            />}
            {colored ? (
                <>
                    <path
                        fill="#000"
                        d="M48 16H8v40h40V16Z"
                    />
                    <path
                        fill="#fff"
                        d="M30 47H13v4h17v-4Z"
                    />
                </>
            ) : (
                <path
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M48 16H8v40h40V16ZM30 47H13v4h17v-4Z"
                />
            )}
        </SvgIcon>
    );
}
